export default function (level, args) {
  // @todo: append log to localStorage
  return level
}



// WEBPACK FOOTER //
// ./src/appenders/localstorage.js